import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from './TranslationContext';
import { useRTL } from './RTLContext';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return 'he';
  });

  const { setLanguage: setTranslationLanguage } = useTranslation();
  const { setIsRTL } = useRTL();

  useEffect(() => {
    localStorage.setItem('language', language);
    setTranslationLanguage(language.toUpperCase());
    setIsRTL(language === 'he');
  }, [language, setTranslationLanguage, setIsRTL]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'he' ? 'en' : 'he');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
} 